export function axDefaultCompareFunction(a, b) {
    return String(a).localeCompare(String(b));
}
